import { render } from "./ReSend.vue?vue&type=template&id=a0d4dca8&scoped=true&ts=true"
import script from "./ReSend.vue?vue&type=script&lang=ts"
export * from "./ReSend.vue?vue&type=script&lang=ts"

import "./ReSend.vue?vue&type=style&index=0&id=a0d4dca8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0d4dca8"]])

export default __exports__